import { render, staticRenderFns } from "./smartProduct.vue?vue&type=template&id=4a05c8b5"
import script from "./smartProduct.vue?vue&type=script&lang=js"
export * from "./smartProduct.vue?vue&type=script&lang=js"
import style0 from "./smartProduct.vue?vue&type=style&index=0&id=4a05c8b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports